import '../static/css/checkbox.css';

const Checkbox = ({ checkbox, label, setCheckbox }) => {
    const toggleCheck = () => {
        setCheckbox(!checkbox);
    };

    return (
        <div>
            <label className={`form-check-label d-inline-flex ${checkbox ? 'checked' : ''} py-2`}>
                <input
                    type="checkbox"
                    className="form-check-input"
                    checked={checkbox}
                    onChange={toggleCheck}
                />
                <span>{label}</span>
            </label>
        </div>
    );
};

export default Checkbox;
